// extracted by mini-css-extract-plugin
export default {"stepsList":"stepsLength_stepsList__UlU20","stepItem":"stepsLength_stepItem__nBipz","stepNotActive":"stepsLength_stepNotActive__UkZUu","stepActive":"stepsLength_stepActive__jYgvy"};